import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

type NavLink = { id: string; label: string; href: string };

export function useNavLinkClick(links: NavLink[]) {
  const navigate = useNavigate();
  return useCallback(
    (id: string) => {
      const target = links.find((link) => link.id === id);
      if (!target) return;
      navigate(target.href);
    },
    [links, navigate]
  );
}
